var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrontHead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.30163 3.57777C0.273531 7.59704 1.60583 14.254 3.02549 17.08C2.5887 16.8708 1.58406 16.515 1.05988 16.7663C0.404649 17.0803 0.840898 19.2162 1.09631 19.7058C1.42392 20.3338 2.37034 21.7903 2.69795 22.7324C2.96004 23.486 4.33602 23.2557 4.99125 23.0464C4.72916 24.8048 5.75568 26.7098 6.30171 27.4424C11.5435 33.4085 19.1177 30.8385 22.0241 27.2055C23.3354 25.5664 23.374 23.7882 23.3377 23.0464C23.7745 23.151 24.7136 23.2976 24.9757 23.0464C25.3033 22.7324 25.6305 21.2771 26.2858 20.6491C26.9698 19.9934 26.9414 19.2783 26.9414 17.3943C26.9414 15.887 25.3023 17.0431 24.9757 17.3943C26.2858 10.8145 24.6467 6.22469 21.0407 3.27431C17.1068 0.652088 12.3297 -0.441504 6.30163 3.57777Z",
    stroke: "#202E5F",
    strokeWidth: 0.65564,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontHead);
export default __webpack_public_path__ + "static/media/FrontHead.ae8a3fe308c8b32e993652c8852ba9c9.svg";
export { ForwardRef as ReactComponent };